<div class="ibox detailed-view-ibox" *ngIf="passOnLogService.showDetailedView && passOnLogService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">Log ID: {{passOnLogService.selectedItemData.passOnLogNumber}}</div>
        <span class="close-detailed-view" (click)="passOnLogService.toggleDetailedView(null)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md" [ngClass]="{'no-action-button': actionButtonIsNotAvailable()}">
            <form #form="ngForm" submittable autocomplete="off" class="content">
                <div class="row m-b-xs"
                     *ngIf="passOnLogService.buildings.length > 1"
                     (dblclick)="setEditModeFor(passOnLogService.selectedItemData, 'building', true, form)">
                    <div class="dv-label col-md-4">
                        <label>Building</label>
                    </div>
                    <div class="dv-value col-md-8" *ngIf="!passOnLogService.selectedItemData.formFields.building.editMode">
                        <span>{{passOnLogService.selectedItemData.buildingName || '-'}}</span>
                        <i *ngIf="passOnLogService.selectedItemData.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(passOnLogService.selectedItemData, 'building', true, form)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-8"
                         *ngIf="passOnLogService.selectedItemData.formFields.building.editMode">
                        <select class="form-control"
                                name="building"
                                [disabled]="buildingSelectIsDisabled"
                                [ngModel]="passOnLogService.selectedItemData.buildingId">
                            <option value=""></option>
                            <option *ngFor="let building of passOnLogService.buildingsForUpdate" [value]="building.id">
                                {{building.name}}
                            </option>
                        </select>
                        <button type="button" (click)="applyChanges(passOnLogService.selectedItemData, form, {building: form.value.building}, 'building')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(passOnLogService.selectedItemData, 'building', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs" (dblclick)="setEditModeFor(passOnLogService.selectedItemData, 'subject', true)">
                    <div class="dv-label col-md-4">
                        <label>Subject</label>
                    </div>
                    <div class="dv-value col-md-8" *ngIf="!passOnLogService.selectedItemData.formFields.subject.editMode">
                        <span>{{passOnLogService.selectedItemData.subject || '-'}}</span>
                        <i *ngIf="passOnLogService.selectedItemData.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(passOnLogService.selectedItemData, 'subject', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-8"
                         *ngIf="passOnLogService.selectedItemData.formFields.subject.editMode">
                        <input class="form-control"
                               name="subject"
                               [ngModel]="passOnLogService.selectedItemData.subject"
                               required
                               maxlength="255"
                               (keyup.enter)="applyChanges(passOnLogService.selectedItemData, form, {subject: form.value.subject})">
                        <button type="button" (click)="applyChanges(passOnLogService.selectedItemData, form, {subject: form.value.subject})">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(passOnLogService.selectedItemData, 'subject', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs" (dblclick)="setEditModeFor(passOnLogService.selectedItemData, 'announcement', true)">
                    <div class="dv-label col-md-4">
                        <label>Announcement</label>
                    </div>
                    <div class="dv-value col-md-8"
                         *ngIf="!passOnLogService.selectedItemData.formFields.announcement.editMode">
                        <pre>{{passOnLogService.selectedItemData.announcement || '-'}}</pre>
                        <i *ngIf="passOnLogService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(passOnLogService.selectedItemData, 'announcement', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-8"
                         *ngIf="passOnLogService.selectedItemData.formFields.announcement.editMode">
                        <textarea class="form-control"
                                  name="announcement"
                                  [ngModel]="passOnLogService.selectedItemData.announcement"
                                  required
                                  maxlength="255"
                                  (keyup.enter)="applyChanges(passOnLogService.selectedItemData, form, {announcement: form.value.announcement})">
                        </textarea>
                        <button type="button" (click)="applyChanges(passOnLogService.selectedItemData, form, {announcement: form.value.announcement})">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(passOnLogService.selectedItemData, 'announcement', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-4">
                        <label>Start Date</label>
                    </div>
                    <div class="dv-value col-md-8">
                        {{passOnLogService.selectedItemData.startDate | mccDate}}
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-4">
                        <label>End Date</label>
                    </div>
                    <div class="dv-value col-md-8">
                        {{passOnLogService.selectedItemData.endDate | mccDate}}
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-4">
                        <label>Status</label>
                    </div>
                    <div class="col-md-8">
                        <span class="label label-current"
                              *ngIf="passOnLogService.selectedItemData.status === 'current'">
                            Current
                        </span>
                        <span class="label label-future"
                              *ngIf="passOnLogService.selectedItemData.status === 'future'">
                            Future
                        </span>
                        <span class="label label-past"
                              *ngIf="passOnLogService.selectedItemData.status === 'past'">
                            Past
                        </span>
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-4">
                        <label>Created By</label>
                    </div>
                    <div class="dv-value col-md-8">
                        {{passOnLogService.selectedItemData.createdBy.fullName}}
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-4">
                        <label>Created On</label>
                    </div>
                    <div class="dv-value col-md-8">
                        {{passOnLogService.selectedItemData.createdAt | date:"dd.MM.yyyy 'at' hh:mm a"}}
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-4">
                        <label>Read By</label>
                    </div>
                    <div class="dv-value col-md-8">
                        <div class="read-by-line"
                             [title]="reader.fullName + ' (' + reader.email + ')'"
                             *ngFor="let reader of passOnLogService.selectedItemData.readers">
                            {{reader.fullName + ' (' + reader.email + ')'}}
                        </div>
                    </div>
                </div>

                <!--<hr>-->

                <!--<div class="row m-b-xs" (dblclick)="!authenticationService.userIsResident && passOnLogService.selectedItemData.status === 'received' && setEditModeFor(parcelsService.selectedItemData, 'parcelPostService', true)">-->
                    <!--<div class="dv-label col-md-4">-->
                        <!--<label>Courier</label>-->
                    <!--</div>-->
                    <!--<div class="dv-value col-md-8" *ngIf="!passOnLogService.selectedItemData.formFields.parcelPostService.editMode">-->
                        <!--<span>{{passOnLogService.selectedItemData.pickedUpByPostServiceName ||-->
                                <!--passOnLogService.selectedItemData.returningByName ||-->
                                <!--passOnLogService.selectedItemData.parcelPostServiceName || '-'}}</span>-->
                        <!--<i *ngIf="!authenticationService.userIsResident && parcelsService.selectedItemData.status === 'received' && parcelsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"-->
                           <!--(click)="setEditModeFor(parcelsService.selectedItemData, 'parcelPostService', true)"-->
                           <!--data-toggle="tooltip" data-placement="top" title="Edit"></i>-->
                    <!--</div>-->
                    <!--<div class="dv-value-edit col-md-8" *ngIf="parcelsService.selectedItemData.formFields.parcelPostService.editMode">-->
                        <!--<select class="form-control" name="parcelPostService"-->
                                <!--[ngModel]="parcelsService.selectedItemData.parcelPostServiceId">-->
                            <!--<option value=""></option>-->
                            <!--<option *ngFor="let postService of parcelsService.postServices" [value]="postService.id">-->
                                <!--{{postService.name}}-->
                            <!--</option>-->
                        <!--</select>-->
                        <!--<button type="button" (click)="applyChanges(parcelsService.selectedItemData, form, {parcelPostService: form.value.parcelPostService})">-->
                            <!--<i class="fa fa-check"></i>-->
                        <!--</button>-->
                        <!--<button type="button" (click)="setEditModeFor(parcelsService.selectedItemData, 'parcelPostService', false)">-->
                            <!--<i class="fa fa-times"></i>-->
                        <!--</button>-->
                    <!--</div>-->
                <!--</div>-->
            </form>

            <hr *ngIf="passOnLogService.selectedItemData.isCanEdit">

            <div class="btn-group dropup" *ngIf="passOnLogService.selectedItemData.isCanEdit">
                <a data-toggle="dropdown"class="btn btn-primary btn-sm dropdown-toggle">
                    Actions <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                    <li *ngIf="passOnLogService.selectedItemData.isCanEdit"
                        (click)="passOnLogService.editPassOnLog(passOnLogService.selectedItemData)">
                        <a>Edit</a>
                    </li>
                    <li *ngIf="passOnLogService.selectedItemData.isCanDelete"
                        (click)="passOnLogService.deletePassOnLog(passOnLogService.selectedItemData)">
                        <a>Delete</a>
                    </li>
                    <li (click)="showHistory(passOnLogService.selectedItemData)"><a>History</a></li>
                    <li (click)="showStatusHistory(passOnLogService.selectedItemData)"><a>Status History</a></li>
                    <li *ngIf="passOnLogService.selectedItemData.markAsRead && passOnLogService.selectedItemData.markAsRead.enable"
                        (click)="passOnLogService.readPassOnLog(passOnLogService.selectedItemData, false)">
                        <a>Mark as Unread</a>
                    </li>
                    <li *ngIf="!passOnLogService.selectedItemData.markAsRead || !passOnLogService.selectedItemData.markAsRead.enable"
                        (click)="passOnLogService.readPassOnLog(passOnLogService.selectedItemData, true)">
                        <a>Mark as Read</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-detailed-view/pass-on-log-detailed-view.component.html